<div class="history-container">
  <div *ngIf="error" class="error">{{ error }}</div>
  <div class="table-container" *ngIf="!error && bids.length > 0">
    <table>
      <thead>
        <tr>
          <th>Bid Start</th>
          <th>Bid End</th>
          <th>Bid Type</th>
          <th>Bid Unit</th>
          <th>Bid Price</th>
          <th>Transaction Type</th>
          <th>Allocation Start</th>
          <th>Allocation End</th>
          <th>Status</th>
          <th>Trade Start</th>
          <th>Trade End</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let bid of bids">
          <td>{{ bid.bid_start }}</td>
          <td>{{ bid.bid_end }}</td>
          <td>{{ bid.bid_type }}</td>
          <td>{{ bid.energy_amount }}</td>
          <td>{{ bid.bid_price }}</td>
          <td>{{ bid.transaction_type }}</td>
          <td>{{ bid.allocation_start }}</td>
          <td>{{ bid.allocation_end }}</td>
          <td>{{ bid.status }}</td>
          <td>{{ bid.trade_start }}</td>
          <td>{{ bid.trade_end }}</td>
          <td>
            <button
              [ngClass]="{
                'active-btn': bid.status === 'ACTIVE',
                'accepted-btn': bid.status === 'ACCEPTED',
                'rejected-btn': bid.status === 'REJECTED',
                'cancelled-btn': bid.status === 'CANCELLED',
                'closed-btn': bid.status === 'CLOSED'
              }"
              (click)="navigateTo(bid)"
            >
              Go
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!error && bids.length === 0">No bids available.</div>
  <app-pagination
    *ngIf="!error && bids.length > 0"
    [totalItems]="totalItems"
    [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage"
    (pageChanged)="onPageChanged($event)"
  >
  </app-pagination>
</div>
